var map = {
	"./1.jpg": 64854,
	"./10.jpg": 13132,
	"./11.jpg": 58505,
	"./12.jpg": 84798,
	"./3.jpg": 20068,
	"./4.jpg": 62799,
	"./5.jpg": 86418,
	"./6.jpg": 5373,
	"./7.jpg": 79808,
	"./8.jpg": 78939,
	"./9.jpg": 77630,
	"./FOX 8.jpg": 51200,
	"./bird 2.jpg": 63220,
	"./bird 3.jpg": 35025,
	"./bird 7.jpg": 19021,
	"./birds 1.jpg": 23350,
	"./birds.jpg": 82563,
	"./boy 2.jpg": 64315,
	"./fox.jpg": 54528,
	"./lion 10.jpg": 33698,
	"./rabbit 10.jpg": 65676,
	"./rabbit 3.jpg": 77444,
	"./sun.jpg": 14201,
	"./teddy.jpg": 41857,
	"./zerafee.jpg": 4731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66829;